import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/src/locale/es";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const colors = require("./colors.js");

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

Vue.use(Vuetify);

// eslint-disable-next-line @typescript-eslint/no-var-requires
const money = require("v-money");
Vue.use(money.default, {
  decimal: ",",
  thousands: ".",
  precision: 2,
  masked: false
});

const vuetify = new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.primary,
        secondary: colors.secondary,
        accent: colors.accent,
        error: colors.error,
        info: colors.info,
        success: colors.success,
        warning: colors.warning
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  },
  icons: {
    iconfont: "md"
  }
});

// TODO: Why is there a v-money and also a v-currency-field

// eslint-disable-next-line @typescript-eslint/no-var-requires
const VCurrencyField = require("v-currency-field");

import { VTextField } from "vuetify/lib";
Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField.default, {
  locale: "es-ES",
  decimalLength: 2,
  autoDecimalMode: true,
  min: 0,
  max: null,
  defaultValue: 0
});

export default vuetify;
